import { css } from 'styled-components';
export const square = (size) => css `
  height: ${size};
  width: ${size};
`;
export const squareForcedMinDimensions = (size) => css `
  ${square(size)}
  min-height: ${size};
  min-width: ${size};
`;
export const circle = (size) => css `
  ${square(size)}
  border-radius: ${size};
`;
export const circleForcedMinDimensions = (size) => css `
  ${squareForcedMinDimensions(size)}
  border-radius: ${size};
`;
//# sourceMappingURL=shape.js.map